export default {
  '阳光跑班级报表': '陽光跑班級報表',
  '阳光跑个人报表': '陽光跑個人報表',
  '班级报表': '班級報表',
  '学生报表': '學生報表',
  '跑步人数': '跑步人數',
  '未跑人数': '未跑人數',
  '人均里程': '人均里程',
  '班级详情': '班級詳情',
  '导出未跑名单': '導出未跑名單',
  '个人报告': '個人報告',
  '运动时长': '運動時長',
  '运动次数': '運動次數',
  '功能开发中': '功能開發中'
}
